package diana.soleil.design.iraniancanadienbazzar.feature.profile

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import diana.soleil.design.iraniancanadienbazzar.core.common.requestPushPermission
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import androidx.compose.foundation.layout.FlowRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppearanceSwitcher
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LanguageSwitcher
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.devmenu.DeveloperMenuContent
import diana.soleil.design.iraniancanadienbazzar.core.model.AppearanceMode
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_dark
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_light
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.appearance_system
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_english
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_french
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.lang_persian
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_blocked_users
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_blocked_users_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_delete_account
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_delete_account_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_dev_menu_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_invite_message
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_pro_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_admin
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_admin_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_analytics
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_analytics_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_appearance
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_daily_gem
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_daily_gem_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_dashboard
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_dashboard_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_email_updates
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_email_updates_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_interests
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_interests_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_invite
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_invite_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_language
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_legal
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_legal_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_moderation
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_moderation_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_notifications
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_notifications_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_save_failed
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tour
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_setting_tour_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_sign_out
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.profile_version
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_discoverable_sub
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_discoverable_title
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_account
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_actions
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_admin
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_business
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_community
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_display
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_help
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_notifications
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_privacy
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_section_pro
import diana.soleil.design.iraniancanadienbazzar.feature.profile.resources.settings_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/**
 * Taps on the build-number line that reveal the debug Developer Menu (docs/DEVELOPER_MENU.md).
 * Was a bare `5` inline before the settings split.
 */
private const val DEV_MENU_TAPS = 5

/**
 * Every preference in the app, grouped.
 *
 * Split out of `ProfileScreen` (2026-08-02, owner: "this section is very messy"). Profile used to end
 * in ONE `AppCard` holding ~16 undifferentiated rows that spanned navigation, three consent toggles,
 * legal, admin tools and two destructive actions — Sign Out sat directly under "App tour". Settings is
 * now its own pushed route with real section headers, and the Profile tab is free to be a profile.
 *
 * Sections are ordered by how often they're touched, with the irreversible ones last and visually
 * separated.
 */
@Composable
fun SettingsScreen(
    onBack: () -> Unit,
    developerMenuEnabled: Boolean,
    onSignOut: () -> Unit,
    modifier: Modifier = Modifier,
    versionName: String = "1.0.0",
    versionCode: String = "1",
    firebaseEnv: String = "dev",
    isGuest: Boolean = true,
    currentLanguage: Language = Language.Default,
    currentAppearance: AppearanceMode = AppearanceMode.System,
    adminEnabled: Boolean = false,
    /** True when the account can reach the console as a MODERATOR only — the row then reads
     * "Moderation" rather than "Admin console", to set the right expectation. */
    moderatorConsole: Boolean = false,
    dashboardEnabled: Boolean = false,
    /** Replays the spotlight feature tour (null hides the row). */
    onReplayTour: (() -> Unit)? = null,
    /** `feature_payments_enabled` — gates the Mahaleh Pro section. */
    paymentsEnabled: Boolean = false,
    // NO `= {}` defaults below this line, deliberately. "Edit profile" shipped dead for exactly that
    // reason: the row existed, the call site never passed a handler, and the default silently
    // swallowed every tap. A missing wire must be a compile error, not a row that does nothing.
    onLanguageSelected: (Language) -> Unit,
    onAppearanceSelected: (AppearanceMode) -> Unit,
    onOpenAdmin: () -> Unit,
    onOpenDashboard: () -> Unit,
    onOpenBlockedUsers: () -> Unit,
    onOpenTerms: () -> Unit,
    onDeleteAccount: () -> Unit,
    viewModel: ProfileViewModel = koinViewModel(),
) {
    val data by viewModel.state.collectAsStateWithLifecycle()
    val preferences = koinInject<AppPreferences>()
    val shareService = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.ShareService>()
    val shareConfig = koinInject<diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig>()
    val inviteMessage = stringResource(Res.string.profile_invite_message, shareConfig.inviteLink())
    var analyticsConsent by remember { mutableStateOf(preferences.analyticsConsent) }
    var buildTaps by remember { mutableStateOf(0) }
    var showDevMenu by remember { mutableStateOf(false) }
    var showInterestsSheet by remember { mutableStateOf(false) }

    LazyColumn(
        modifier = modifier
            .background(AppTheme.colors.background)
            .appContentWidth(AppTheme.sizes.contentMaxWidth)
            .fillMaxHeight()
            .statusBarsPadding()
            .navigationBarsPadding(),
        contentPadding = PaddingValues(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        item {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                AppIconButton(
                    iconName = "arrow_back",
                    contentDescription = stringResource(Res.string.settings_back_a11y),
                    onClick = onBack,
                    tint = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.settings_title),
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.onSurface,
                )
            }
        }

        // ---- Account -------------------------------------------------------------------------
        // "Edit profile" USED to head this section. It was never wired at the call site (it fell back
        // to the `= {}` default and did nothing when tapped), and it was redundant besides — the
        // pencil beside your name on the Profile tab opens the same sheet. Removed rather than wired:
        // one entry point per action. The callbacks below no longer carry `= {}` defaults, so the next
        // missing wire is a compile error instead of a dead row.
        if (!isGuest) {
            settingsSection(Res.string.settings_section_account) {
                SettingsRow(
                    "interests", stringResource(Res.string.profile_setting_interests),
                    { showInterestsSheet = true },
                    subtitle = stringResource(Res.string.profile_setting_interests_sub),
                )
                SettingsRow(
                    "block", stringResource(Res.string.profile_blocked_users), onOpenBlockedUsers,
                    subtitle = stringResource(Res.string.profile_blocked_users_sub),
                )
            }
        }

        // ---- Display ---------------------------------------------------------------------------
        // Language and Appearance were two separate cards under one PREFERENCES header, each with its
        // own internal label — three stacked cards of two different shapes reading as unrelated
        // blocks. They are the same KIND of setting (how the app looks), so they are now one card with
        // a separator, matching the grouped-rows treatment every other section uses.
        item { SettingsSectionHeader(stringResource(Res.string.settings_section_display)) }
        item {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    SettingsChoiceBlock(stringResource(Res.string.profile_setting_language)) {
                        // Language names localized in the ACTIVE UI language (English UI: "Persian";
                        // Farsi UI: «انگلیسی/فرانسوی/فارسی») — owner direction 2026-07-12.
                        val langEnglish = stringResource(Res.string.lang_english)
                        val langFrench = stringResource(Res.string.lang_french)
                        val langPersian = stringResource(Res.string.lang_persian)
                        LanguageSwitcher(
                            selected = currentLanguage,
                            onSelect = onLanguageSelected,
                            labelFor = { language ->
                                when (language) {
                                    Language.EN -> langEnglish
                                    Language.FR -> langFrench
                                    Language.FA -> langPersian
                                }
                            },
                        )
                    }
                    HorizontalDivider(color = AppTheme.colors.outlineVariant)
                    SettingsChoiceBlock(stringResource(Res.string.profile_setting_appearance)) {
                        val appearanceSystem = stringResource(Res.string.appearance_system)
                        val appearanceLight = stringResource(Res.string.appearance_light)
                        val appearanceDark = stringResource(Res.string.appearance_dark)
                        AppearanceSwitcher(
                            selected = currentAppearance,
                            onSelect = onAppearanceSelected,
                            labelFor = { mode ->
                                when (mode) {
                                    AppearanceMode.System -> appearanceSystem
                                    AppearanceMode.Light -> appearanceLight
                                    AppearanceMode.Dark -> appearanceDark
                                }
                            },
                        )
                    }
                }
            }
        }

        // ---- Notifications ---------------------------------------------------------------------
        // Split out of the old PREFERENCES grab-bag: "how do you want to be contacted" is a different
        // question from "how should the app look", and burying two consent switches under a generic
        // header is exactly what made this screen hard to scan.
        // Guests are excluded entirely: every switch in here writes to `users/{uid}`, and the
        // repository refuses an anonymous account (AppError.Unauthorized). Before this gate a guest
        // could flip the push toggle, watch it move, and get "Couldn't save your preference — check
        // your connection", which is both a dead control and a false diagnosis (the network is fine;
        // there is simply no account to save to). Email updates were already guest-gated; the push
        // rows were not. Found in device QA 2026-09-05.
        if (!isGuest) {
        item { SettingsSectionHeader(stringResource(Res.string.settings_section_notifications)) }
        item {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    // Push opt-in, persisted to users/{uid}.pushEnabled — the retention Functions
                    // (e.g. onEventApproved) skip a user who turns this off. Seeded from the account
                    // doc (re-keys when it loads); optimistic on toggle.
                    var notificationsEnabled by remember(data.pushEnabled) { mutableStateOf(data.pushEnabled) }
                    SettingsToggleRow(
                        iconName = "notifications",
                        title = stringResource(Res.string.profile_setting_notifications),
                        subtitle = stringResource(Res.string.profile_setting_notifications_sub),
                        checked = notificationsEnabled,
                        onCheckedChange = {
                            notificationsEnabled = it
                            viewModel.setPushEnabled(it)
                            // Turning push on is the consent moment — ask the OS now, not at launch.
                            if (it) requestPushPermission()
                        },
                    )
                    // The daily Hidden Gem is the one unsolicited recurring push we send, so it gets
                    // its own switch — otherwise muting it would mean losing order and chat pushes
                    // too. Hidden while the master switch is off: it would be a no-op control, and a
                    // toggle that does nothing reads as a bug.
                    if (notificationsEnabled) {
                        var gemPush by remember(data.gemPushEnabled) { mutableStateOf(data.gemPushEnabled) }
                        SettingsToggleRow(
                            iconName = "auto_awesome",
                            title = stringResource(Res.string.profile_setting_daily_gem),
                            subtitle = stringResource(Res.string.profile_setting_daily_gem_sub),
                            checked = gemPush,
                            onCheckedChange = {
                                gemPush = it
                                viewModel.setGemPushEnabled(it)
                            },
                        )
                    }
                    // CASL express consent for marketing emails — default OFF (Canadian anti-spam law
                    // forbids pre-checked consent); guests have no email address to consent with.
                    // sendCampaign's email channel only targets consented users.
                    if (!isGuest) {
                        var emailUpdates by remember(data.emailMarketingConsented) {
                            mutableStateOf(data.emailMarketingConsented)
                        }
                        SettingsToggleRow(
                            iconName = "mail",
                            title = stringResource(Res.string.profile_setting_email_updates),
                            subtitle = stringResource(Res.string.profile_setting_email_updates_sub),
                            checked = emailUpdates,
                            onCheckedChange = {
                                emailUpdates = it
                                viewModel.setEmailMarketingConsent(it)
                            },
                        )
                    }
                    // Preference writes are optimistic; if one fails (offline, session expired) the
                    // toggle would otherwise LOOK saved — especially bad for the CASL consent record.
                    if (data.prefsWriteFailed) {
                        Text(
                            text = stringResource(Res.string.profile_setting_save_failed),
                            style = AppTheme.typography.labelSm,
                            color = AppTheme.colors.error,
                            modifier = Modifier.padding(horizontal = AppTheme.spacing.md),
                        )
                    }
                }
            }
        }
        }

        // ---- Privacy ---------------------------------------------------------------------------
        // Who can find you, and what leaves the device. Discoverable lived under ACCOUNT, which put a
        // "the whole city can message you" switch next to a colour theme; it belongs with the other
        // visibility choice instead.
        item { SettingsSectionHeader(stringResource(Res.string.settings_section_privacy)) }
        item {
            AppCard(modifier = Modifier.fillMaxWidth()) {
                Column {
                    // Find-your-people opt-in. Moved off the Profile tab 2026-08-03 (owner): the
                    // profile shows who you ARE, settings hold the switches. Re-sends the current
                    // bio/intents because setDiscoveryProfile writes the whole card. Guests have no
                    // card to publish.
                    if (!isGuest) {
                        val myCard by viewModel.myCard.collectAsStateWithLifecycle()
                        SettingsToggleRow(
                            iconName = "person_search",
                            title = stringResource(Res.string.settings_discoverable_title),
                            subtitle = stringResource(Res.string.settings_discoverable_sub),
                            checked = myCard?.discoverable == true,
                            onCheckedChange = viewModel::setDiscoverable,
                        )
                    }
                    SettingsToggleRow(
                        iconName = "analytics",
                        title = stringResource(Res.string.profile_setting_analytics),
                        subtitle = stringResource(Res.string.profile_setting_analytics_sub),
                        checked = analyticsConsent,
                        onCheckedChange = {
                            analyticsConsent = it
                            preferences.analyticsConsent = it
                        },
                    )
                }
            }
        }

        // ---- Mahaleh Pro -----------------------------------------------------------------------
        // Moved from the Profile tab 2026-08-03. Same gate as before: hidden unless
        // feature_payments_enabled is on, EXCEPT for an existing subscriber, who must keep a route to
        // the Billing Portal even while payments are flagged off.
        if (paymentsEnabled || data.proActive) {
            // Its own CAPS section string, not profile_pro_title — that one is the title-case brand
            // name used inside the card, and reusing it made this the only lowercase header on the screen.
            item { SettingsSectionHeader(stringResource(Res.string.settings_section_pro)) }
            item {
                ProUpgradeCard(
                    proActive = data.proActive,
                    onCheckout = viewModel::startProCheckout,
                    onManage = viewModel::openBillingPortal,
                )
            }
        }

        // ---- Business ------------------------------------------------------------------------
        if (dashboardEnabled) {
            settingsSection(Res.string.settings_section_business) {
                SettingsRow(
                    "storefront", stringResource(Res.string.profile_setting_dashboard), onOpenDashboard,
                    subtitle = stringResource(Res.string.profile_setting_dashboard_sub),
                )
            }
        }

        // ---- Community -----------------------------------------------------------------------
        settingsSection(Res.string.settings_section_community) {
            SettingsRow(
                "person_add", stringResource(Res.string.profile_setting_invite),
                { shareService.share(inviteMessage) },
                subtitle = stringResource(Res.string.profile_setting_invite_sub),
            )
        }

        // ---- Help & legal --------------------------------------------------------------------
        settingsSection(Res.string.settings_section_help) {
            if (onReplayTour != null) {
                SettingsRow(
                    "tour", stringResource(Res.string.profile_setting_tour), onReplayTour,
                    subtitle = stringResource(Res.string.profile_setting_tour_sub),
                )
            }
            SettingsRow(
                "description", stringResource(Res.string.profile_setting_legal), onOpenTerms,
                subtitle = stringResource(Res.string.profile_setting_legal_sub),
            )
        }

        // ---- Admin (role-gated) ---------------------------------------------------------------
        if (adminEnabled) {
            settingsSection(Res.string.settings_section_admin) {
                if (moderatorConsole) {
                    SettingsRow(
                        "shield", stringResource(Res.string.profile_setting_moderation), onOpenAdmin,
                        subtitle = stringResource(Res.string.profile_setting_moderation_sub),
                    )
                } else {
                    SettingsRow(
                        "admin_panel_settings", stringResource(Res.string.profile_setting_admin), onOpenAdmin,
                        subtitle = stringResource(Res.string.profile_setting_admin_sub),
                    )
                }
            }
        }

        // ---- Account actions (irreversible — last, and on their own) ---------------------------
        settingsSection(Res.string.settings_section_actions) {
            SettingsRow("logout", stringResource(Res.string.profile_sign_out), onSignOut, destructive = true)
            // Store-required in-app account deletion (Apple 5.1.1(v) / Play User Data); guests have
            // nothing to delete — the row only shows for real accounts.
            if (!isGuest) {
                SettingsRow(
                    "delete_forever",
                    stringResource(Res.string.profile_delete_account),
                    onDeleteAccount,
                    subtitle = stringResource(Res.string.profile_delete_account_sub),
                    destructive = true,
                )
            }
        }

        item {
            // Real build identity, and the 5-tap target that reveals the Developer Menu in debug
            // builds. The env suffix makes it unmistakable which backend you're on — critical for the
            // prod-preview build, which is a debug build pointed at real prod data.
            val onProd = firebaseEnv == "prod"
            Text(
                text = stringResource(Res.string.profile_version, versionName, versionCode) +
                    if (developerMenuEnabled) " · $firebaseEnv" else "",
                style = AppTheme.typography.labelSm,
                color = if (onProd && developerMenuEnabled) {
                    AppTheme.colors.error
                } else {
                    AppTheme.colors.onSurfaceVariant.copy(alpha = 0.6f)
                },
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable(enabled = developerMenuEnabled) {
                        buildTaps += 1
                        if (buildTaps >= DEV_MENU_TAPS) {
                            buildTaps = 0
                            showDevMenu = true
                        }
                    },
            )
        }
    }

    if (showInterestsSheet) {
        val interestSelection by viewModel.interests.collectAsStateWithLifecycle()
        val interestOptions by viewModel.interestOptions.collectAsStateWithLifecycle()
        AppBottomSheet(
            onDismissRequest = { showInterestsSheet = false },
            title = stringResource(Res.string.profile_setting_interests),
        ) {
            Column(
                modifier = Modifier.padding(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = stringResource(Res.string.profile_setting_interests_sub),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                androidx.compose.foundation.layout.FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    interestOptions.forEach { category ->
                        AppChip(
                            label = category.displayName(currentLanguage),
                            selected = category.id in interestSelection,
                            leadingIcon = diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey(category.id),
                            onClick = { viewModel.toggleInterest(category.id) },
                        )
                    }
                }
            }
        }
    }

    if (showDevMenu) {
        AppBottomSheet(
            onDismissRequest = { showDevMenu = false },
            title = stringResource(Res.string.profile_dev_menu_title),
        ) { DeveloperMenuContent() }
    }
}

/** Section header + a card wrapping the rows, as one LazyList entry pair. */
private fun androidx.compose.foundation.lazy.LazyListScope.settingsSection(
    title: StringResource,
    rows: @Composable () -> Unit,
) {
    item { SettingsSectionHeader(stringResource(title)) }
    item {
        AppCard(modifier = Modifier.fillMaxWidth()) {
            Column { rows() }
        }
    }
}

/**
 * A labelled block of choice chips (Language, Appearance) sized to sit in the same card as
 * [SettingsRow]s without looking like a different component. Padding matches a settings row's so the
 * label lines up with the row titles above and below it.
 */
@Composable
private fun SettingsChoiceBlock(label: String, content: @Composable () -> Unit) {
    Column(
        modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Text(
            text = label,
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurfaceVariant,
        )
        content()
    }
}

@Composable
private fun SettingsSectionHeader(title: String) {
    Text(
        text = title,
        style = AppTheme.typography.labelMd,
        color = AppTheme.colors.onSurfaceVariant,
    )
}
